
export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <p className="text-gray-300 mb-6" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Conectamos credores e investidores por meio de soluções seguras e transparentes 
              no mercado de precatórios e direitos creditórios.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/precnacional/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-700 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-600 transition-colors"
              >
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a 
                href="https://www.instagram.com/precnacional/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-700 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-600 transition-colors"
              >
                <i className="ri-instagram-line text-white"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Serviços
            </h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Avaliação e Análise de Precatórios</a></li>
              <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Assessoria e Consultoria Jurídica Especializada</a></li>
              <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Cessão e Compra de Direitos Creditórios</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Contato
            </h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 text-green-400"></i>
                (31) 97217-6645
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2 text-green-400"></i>
                comercial@precnacional.com.br
              </li>
              <li className="flex items-center">
                <i className="ri-map-pin-line mr-2 text-green-400"></i>
                Belo Horizonte, MG
              </li>
            </ul>
          </div>
        </div>
        
        <div className="text-center pt-12 mt-8 border-t border-gray-700">
          <p className="text-gray-400 mb-2" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            © 2025 PrecNacional. Todos os direitos reservados.
          </p>
          <a 
            href="/politica-privacidade" 
            className="text-blue-400 hover:text-blue-300 text-sm underline cursor-pointer"
            style={{ fontFamily: 'Open Sans, sans-serif' }}
          >
            Política de Privacidade e Termos de Uso
          </a>
        </div>
      </div>
    </footer>
  );
}
